function CardLayout({ children, title, className, extraContent }) {
  return (
    <div
      className={`settings-card-layout flex gap-6 flex-col ${className ? className : ""}`}
    >
      {title && (
        <div className="flex items-center gap-3 justify-between title-container">
          <span className="font-title-normal">{title}</span>
          {extraContent}
        </div>
      )}
      {children}
    </div>
  );
}

export default CardLayout;
